import React from "react";
import Text from "components/common/Text";
import Box from "components/common/Box";
import Grid from "components/common/Grid";
import { makeStyles } from "@mui/styles";
import LinkIcon from "@mui/icons-material/Link";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CallIcon from "@mui/icons-material/Call";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";

const RequestViewDetailsVendor = ({ data }) => {
  let history = useHistory();

  const classes = useStyles();


  return (
    <>
      <Box className={classes.grandParent}>
        <Box sx={{ display: "flex" }}>
          <ArrowBackIcon
            sx={{
              fontSize: "22px",
              fontWeight: "bold",
              marginRight: "10px",
              color: "#707070",
            }}
            onClick={() => history.goBack()}
          />
          <Text
            variant="h4"
            component="div"
            gutterBottom
            sx={{ color: "#707070" }}
          >
            {data?.name}
          </Text>
        </Box>
        <Box>
          <Box
            sx={{
              borderBottom: "1px solid #EBEBEB",
              margin: "10px 10px 20px 5px",
              color: "#707070",
            }}
          >
            <Text variant="h" component="div" gutterBottom>
              Basic Details
            </Text>
          </Box>
          <Box className={classes.parentBox}>
            <Box className={classes.image}>
              <img
                src={
                  data?.thumbnail
                    ? data?.thumbnail
                    : "https://www.w3schools.com/howto/img_avatar.png"
                }
                alt="profilePic"
                width="232px"
                height="236px"
                style={{ borderRadius: "4px" }}
              />
            </Box>

            <Box className={classes.childBox}>
              <Box className={classes.subChildBox}>
                <Box>
                  <Text
                    variant="h"
                    component="div"
                    gutterBottom
                    sx={{
                      color: "#707070",
                      marginTop: "5px",
                    }}
                  >
                    {data?.name}
                  </Text>
                </Box>
                <Box
                  sx={{
                    background:
                      "rgba(25, 30, 170, 0.1) 0% 0% no-repeat padding-box",
                    borderRadius: "4px",
                    padding: "3px 7px",
                    color: "#707070",

                    height: "25px",
                    marginLeft: "15px",
                  }}
                >
                  <Text
                    variant="span"
                    component="div"
                    gutterBottom
                    sx={{
                      letterSpacing: "0.28px",
                      opacity: "1",
                      textAlign: "center",
                      color: "#4C72B7",
                    }}
                  >
                    {data?.type}
                  </Text>
                </Box>
              </Box>

              <Box className={classes.textBox}>
                <Grid container rowSpacing={1} spacing={0}>
                  <Grid item xs={1} md={1} lg={1}>
                    <LinkIcon sx={iconStyle} />
                  </Grid>

                  <Grid item xs={11} md={11} lg={11}>
                    <Text
                      variant="a"
                      component="div"
                      gutterBottom
                      sx={{
                        letterSpacing: "0.28px",
                        color: "#707070",
                        opacity: "1",
                        textAlign: "left",
                        textDecoration: "underline",
                        fontSize: "14px",
                        marginTop: "8px",
                        marginLeft: "10px",
                      }}
                    >
                      URL:
                      <a
                        href={data?.station_url}
                        target="_blank"
                        className={classes.webUrl} rel="noreferrer"
                      >
                        
                        {data?.station_url}
                      </a>
                    </Text>
                  </Grid>

                  <Grid item xs={1} md={1} lg={1}>
                    <LocationOnIcon sx={iconStyle} />
                  </Grid>

                  <Grid item xs={11} md={11} lg={11}>
                    <Text
                      variant="a"
                      component="div"
                      gutterBottom
                      sx={{
                        letterSpacing: "0.28px",
                        color: "#707070",
                        opacity: "1",
                        textAlign: "left",
                        marginTop: "8px",
                      }}
                    >
                      {data?.address}
                    </Text>
                  </Grid>
                  <Grid item xs={1} md={1} lg={1}>
                    <AccessTimeIcon sx={iconStyle} />
                  </Grid>

                  <Grid item xs={11} md={11} lg={11}>
                    <Text
                      variant="a"
                      component="div"
                      gutterBottom
                      sx={{
                        letterSpacing: "0.28px",
                        color: "#707070",
                        opacity: "1",
                        textAlign: "left",
                        marginTop: "8px",
                        marginLeft: "5px",
                      }}
                    >
                      {data?.open_time} - {data?.close_time}
                    </Text>
                  </Grid>
                  <Grid item xs={1} md={1} lg={1}>
                    <CallIcon sx={iconStyle} />
                  </Grid>

                  <Grid item xs={4} md={4} lg={4}>
                    <Text
                      variant="a"
                      component="div"
                      gutterBottom
                      sx={{
                        letterSpacing: "0.28px",
                        color: "#707070",
                        opacity: "1",
                        textAlign: "left",
                        marginTop: "5px",
                      }}
                    >
                      {data?.mobile}
                    </Text>
                  </Grid>
                  <Grid item xs={7}>
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <MailOutlineIcon sx={iconStyle}></MailOutlineIcon>
                      <Text
                        variant="a"
                        component="div"
                        gutterBottom
                        sx={{
                          letterSpacing: "0.28px",
                          color: "#707070",
                          opacity: "1",
                          textAlign: "left",
                          marginTop: "5px",
                        }}
                      >
                        {data?.email}
                      </Text>
                    </Box>
                  </Grid>
                </Grid>

                <Box></Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  grandParent: {
    padding: "1rem",
    "@media (max-width:768px)": {
      padding: "0px",
    },
  },
  webUrl: {
    letterSpacing: "0.28px",
    color: "#707070",
    opacity: "1",
    textAlign: "left",
    textDecoration: "underline",
    marginTop: "5px",
  },
  parentBox: {
    display: "flex",
    flexDirection: "row",
    "@media (max-width:768px)": {
      flexDirection: "column",
    },
  },
  childBox: {
    margin: "0px 1rem",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    "@media (max-width:768px)": {
      margin: "0px 0rem",
    },
  },
  subChildBox: {
    width: "100%",
    margin: "0px 1rem",

    display: "flex",
    flexDirection: "row",
    "@media (max-width:768px)": {
      display: "block",
      margin: "0px 0rem",
      textAlign: "center",
    },
  },
  textBox: {
    display: "flex",
    height: "auto",
    color: "#474747",
    width: "50%",
    margin: "0.5rem",

    flexWrap: "wrap",

    "@media (max-width:768px)": {
      width: "100%",
    },
  },
  image: {
    "@media (max-width:768px)": {
      margin: "0px 15vw",
    },
  },
}));

export default RequestViewDetailsVendor;
const iconStyle = { margin: "7px 5px 0px 5px", width: "20px", height: "20px" };
